const prefixChannel = (prefix, keyword) => `${prefix}.${keyword}`;
const BetslipUtilPrefixChannel = x => prefixChannel("BsUtilChannels", x);
/**
 * @namespace
 * @property {object} Broadcast                     - channel for broadcasting messages
 * @property {string} Broadcast.Status              - channel for broadcasting Status messages
 * @property {object} Broadcast.Items               - channel for broadcasting messages for Items
 * @property {string} Broadcast.Items.added         - channel for broadcasting messages for added Items
 * @property {string} Broadcast.Items.removed       - channel for broadcasting messages for removed Items
 * @property {string} Broadcast.Items.cleared       - channel for broadcasting messages for cleared Items
 * @property {object} Listen                        - channel for receiving messages
 * @property {object} Listen.Commands               - channel for receiving messages for Commands
 * @property {string} Listen.Commands.add_items     - channel for receiving messages for add_items Command
 * @property {string} Listen.Commands.remove_items  - channel for receiving messages for remove_items Command
 * @property {string} Listen.Commands.get_status    - channel for receiving messages for get_status Command
 * @property {string} Listen.Commands.clear_slip    - channel for receiving messages for clear_slip Command
 */
export const BetslipUtilChannels = {
    Broadcast: {
        Status: BetslipUtilPrefixChannel("broadcast.status"),
        Items: {
            added: BetslipUtilPrefixChannel("broadcast.items.added"),
            removed: BetslipUtilPrefixChannel("broadcast.items.removed"),
            cleared: BetslipUtilPrefixChannel("broadcast.items.cleared")
        },
    },
    Listen: {
        Commands: {
            add_items: BetslipUtilPrefixChannel("listen.commands.add_items"),
            remove_items: BetslipUtilPrefixChannel("listen.commands.remove_items"),
            get_status: BetslipUtilPrefixChannel("listen.commands.get_status"),
            clear_slip: BetslipUtilPrefixChannel("listen.commands.clear_slip")
        }
    }
};
/**
 * @namespace
 * @property {string} Listen.addSelection - channel for adding a selection to the BetSlip
 * @property {string} Listen.removeSelection - channel for removing a selection from the BetSlip
 * @property {string} Listen.clear - channel for removing all selections from the BetSlip
 * @property {string} Listen.status - channel for requesting all selections from the BetSlip
 * @property {string} Broadcast.status - channel for sending all selections from the BetSlip
 */
export const BetSlipViewsChannels = {
    Listen: {
        addSelection: "BetSlip.listen.addSelection",
        removeSelection: "BetSlip.listen.removeSelection",
        clear: "BetSlip.listen.clear",
        status: "BetSlip.listen.status"
    },
    Broadcast: {
        status: "BetSlip.broadcast.status"
    }
};
//# sourceMappingURL=constants.js.map